module.exports = __webpack_public_path__ + "img/photo_books_2.c46e19e8.png";